import { clsx } from 'clsx';
import { Link } from 'react-router';

// UI
import Menu from '@components/account-menu';
import Button from '@components/button';

//images
import LogoImg from '@assets/logo-2.png';
import ProfileIcon from '@assets/avatar.png';
import DoneIcon from '@assets/icons/done.svg';

// styles
import css from './styles.module.css';

interface IProps {
  error: string | null;
  displayOnMobile?: boolean;
  className?: string;
}

function Loading({ error, displayOnMobile, className }: IProps) {
  return (
    <main
      className={clsx(
        css.root,
        { [css.displayOnMobile]: displayOnMobile },
        className,
      )}
    >
      <header className={css.header}>
        <a className={css.headerLogo} href="/account">
          <img
            src={LogoImg}
            alt="TurboPush"
            title="TurboPush"
            className={css.logoImage}
          />
        </a>

        <Menu
          toggleComponent={
            <img
              className={css.profilePhoto}
              src={ProfileIcon}
              alt=""
              title=""
            />
          }
        />
      </header>

      <footer className={css.headerFooter}>
        <div>
          <h5 className={css.title}>
            {error ? error : 'Loading...'}
            <img
              className={css.doneIcon}
              src={DoneIcon}
              alt=""
              width="24"
              height="24"
            />
          </h5>

          <span className={css.description}>...</span>
        </div>

        <Link className={css.link} to="/account/tariffs">
          <Button>View plans</Button>
        </Link>
      </footer>
    </main>
  );
}

export default Loading;
